export default class ViewOnlineController {
    constructor() {
        const element = document.querySelector(".js-view-count");

        if (element) {
            import(/* webpackChunkName: "ViewOnline" */ "../classes/style/ViewOnline").then(res => {
                const ViewOnline = res.default;
                this.createInstance(ViewOnline, element);
            });
        }
    }

    createInstance(viewOnline, element) {
        return new viewOnline(element);
    }
}
